import { useState } from "react";
import { Button, Tooltip } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useLessonForm } from "./LessonFormContext";
import ActivityReorderPanel from "./ActivityReorderPanel";

/** Opens the reorder panel. Lives in the tab bar, next to the section tabs. */
const ActivityReorderButton: React.FC = () => {
  const { lesson, reorderActivities } = useLessonForm();
  const [isOpen, setIsOpen] = useState(false);

  const canReorder = lesson.activities.length > 1;

  return (
    <>
      <Tooltip
        title={
          canReorder
            ? "Cambiar el orden de las actividades o moverlas entre secciones"
            : "Se necesitan al menos dos actividades para reordenar"
        }
      >
        <Button
          icon={<SwapOutlined rotate={90} />}
          onClick={() => setIsOpen(true)}
          disabled={!canReorder}
        >
          Reordenar actividades
        </Button>
      </Tooltip>
      <ActivityReorderPanel
        open={isOpen}
        activities={lesson.activities}
        onApply={reorderActivities}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default ActivityReorderButton;
